import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../utils/getConfig.ts';
import { GlobalAlertBannerSkeleton } from './types.ts';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

const getEntries = async () =>
  client
    .getEntries<GlobalAlertBannerSkeleton>({
      content_type: 'globalAlertBanner',
      'fields.isLive': true,
    })
    .then(({ items }) => items);

export const useGlobalAlerts = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['globalAlertBanner'],
    queryFn: getEntries,
    staleTime: 60_000 * 3,
  });
  return { alerts: data, isLoading, isError };
};
